 const data ={  
       Approved : 1,
        ApprovedByHR : 20,
        ApprovedByHOU :40,
        ApprovedByHOD : 50,
        ApprovedByEDO : 30,
        ApprovedByEDFI :60,
        ApprovedByMD : 10,
        RejectedByHR : 81,
        RejectedByHOU : 729,
        RejectedByHOD : 243,
        RejectedByEDO : 9,
        RejectedByEDFI : 27,
        RejectedByMD : 3 ,
        Pending :0,
        Declined : 7,
        Cancelled : 11,
        Paid : 13,
        Draft : 17
 }
export default data